import PartTwo from "./parts/PartTwo";
import PartOne from "./parts/partOne";
import Urls from "../../api/endpoints";
import AuthHistory from "./parts/history";
import FormTexts from "../../constants/forms";
import Headings from "../../constants/headings";
import Constants from "../../constants/constants";
import { Row, Col, Button } from "react-bootstrap";
import { formsButtonType } from "../../enums/index";
import {
  NidInquiryStatusType,
  NidRejectReasonType,
  ModalContentType,
} from "../../enums/index";
import { faLessThanEqual, faSpinner } from "@fortawesome/free-solid-svg-icons";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  NotLogin,
  Loading,
  ErrorToast,
  WarningToast,
  ModalContainer,
} from "../../shared/index";
import {
  getNidInquiryStatusText,
  ErrorHandling,
  ErrorHandlingAPI,
  getNidInquiryStatusTextUsetInfo,
} from "../../functions/index";
import {
  acceptInquireNid,
  getSearchedUserLinesAuthDataById,
  inquireNid,
  rejectInquireNid,
  rejectInquireNidByCustomerId,
} from "../../api/requestAxios/userAuth";
import FormsButtonTypeUserInfo from "../../functions/extensions/FormsButtonTypeUserInfo";

function UserAuth(props) {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [lastInquiry, setLastInquiry] = useState(null);
  const [verifyBtn, setVerifyBtn] = useState(false);
  const [acceptBtn, setAcceptBtn] = useState(false);
  const [rejectBtn, setRejectBtn] = useState(false);
  const [showVerifySpinner, setShowVerifySpinner] = useState(false);
  const [showSpinnerAccept, setShowSpinnerAccept] = useState(false);
  const [showSpinnerReject, setShowSpinnerReject] = useState(false);
  const reason = useRef("");
  const reasonCode = useRef(NidRejectReasonType.None());
  const selectedRejectCheckBox = useRef(NidRejectReasonType.None());

  const handleClose = (e = null, submit = null) => {
    if (e) {
      e.preventDefault();
    }

    if (!submit) {
      reason.current = "";
      reasonCode.current = NidRejectReasonType.None();
      selectedRejectCheckBox.current = NidRejectReasonType.None();
    }
    setShow(false);

    if (submit) rejectInquire(e);
  };

  const getSearchedUserLinesAuthDataByIdFn = async (userId) => {
    try {
      const response = await getSearchedUserLinesAuthDataById(userId);
            let data = response?.data;
      
      if (data?.success) {
        debugger
        if (data.nationalCardFile !== null) 
        setBackImage(data.nationalCardFile.dataUrlContent);

        if (data.nidInquiryStatus === "InProgress") {
          
          if (data.activityHistory.inquiryHistoryItems.length !== 0) {
            let _tmp =
              data.activityHistory.inquiryHistoryItems[
                data.activityHistory.inquiryHistoryItems.length - 1
              ].serializedInquiryResult;

            let tempLastInquiry = JSON.parse(_tmp);
            let _tmp2 =
              data.activityHistory.inquiryHistoryItems[
                data.activityHistory.inquiryHistoryItems.length - 1
              ].id;

            tempLastInquiry.Id = _tmp2;

            
            setLastInquiry(tempLastInquiry);
            data.activityHistory.inquiryHistoryItems.sort(function (a, b) {
              return new Date(b.Date) - new Date(a.Date);
            });

            if (!tempLastInquiry.Message) {
              data.firstName = tempLastInquiry.FirstName;
              data.lastName = tempLastInquiry.LastName;
              data.persianBirthDate = tempLastInquiry.BirthDate;
              data.fatherName = tempLastInquiry.FatherName;
            }
          }
          if (data.activityHistory.verificationHistoryItems.length !== 0) {
            data.activityHistory.verificationHistoryItems.sort(function (a, b) {
              return new Date(b.Date) - new Date(a.Date);
            });
          }
        }
        if (!data.nationalCode) {
          setVerifyBtn(true);
        }
        if (data.nidInquiryStatus === "ReadyForInquiry") {
          setAcceptBtn(true);
        }
        if (data.activityHistory.inquiryHistoryItems.length !== 0) {
          data.activityHistory.inquiryHistoryItems.sort(function (a, b) {
            return new Date(b.Date) - new Date(a.Date);
          });
        }
        if (data.activityHistory.verificationHistoryItems.length !== 0) {
          data.activityHistory.verificationHistoryItems.sort(function (a, b) {
            return new Date(b.Date) - new Date(a.Date);
          });
        }
        setCustomer(data);
        setLoading(false);
      } else {
        setLoading(false);
        ErrorHandlingAPI(data);
      }
    } catch (err) {
      
      ErrorHandling(err, "get auth info error", setLoading);
    } 
  };

  const setPageData = useCallback(() => {
     getSearchedUserLinesAuthDataByIdFn(props.userId);
  }, [props.userId, props.token]);

  useEffect(() => {
    setPageData();
  }, [setPageData]);;


//inquire
  const inquire = (e) => {
    e.preventDefault();
    if (
      !customer.firstName ||
      customer.firstName === "" ||
      !customer.lastName ||
      customer.lastInquiry === "" ||
      !customer.fatherName ||
      customer.fatherName === "" ||
      !customer.persianBirthDate ||
      customer.persianBirthDate === ""
    ) {
      ErrorToast(Constants.YouCannotDoInquire);
    } else {
      setShowVerifySpinner(true);
      setVerifyBtn(true);
      let passed = {
        customerId: props.userId,
        lastNidInquiryId: lastInquiry ? lastInquiry.Id : null,
        nationalCode: customer.nationalCode,
        firstName: customer.firstName,
        lastName: customer.lastName,
        birthDate: customer.persianBirthDate,
        fatherName: customer.fatherName,
      };
      inquireNidFn(passed);
    }
  };

  const inquireNidFn = async (passed) => {
    try {
   const response = await inquireNid(passed);
   let data = response?.data;   
   if (!data.success) ErrorHandlingAPI(data);
 } catch (err) {   
   ErrorHandling(err, "accept error");
 } finally {
  setShowVerifySpinner(false);
  setVerifyBtn(false);
  setPageData();

 }
};

//accept
  const acceptInquire = async () => {
    setShowSpinnerAccept(true);
    setAcceptBtn(true);
    try {
      const response = await acceptInquireNid(lastInquiry.Id);
      let data = response?.data;   
       if (!data.success) ErrorHandlingAPI(data);
    } catch (err) {
       ErrorHandling(err, "inquireNId error");
    }
    finally {
      setShowSpinnerAccept(false);
      setAcceptBtn(false);
      setPageData();    
     }
  };

//reject
  const rejectInquire = (e) => {
    e.preventDefault();    
    setShowSpinnerReject(true);
    setRejectBtn(true);
    if (lastInquiry) {
      rejectInquireNidFn(lastInquiry.Id, reasonCode.current, reason.current);
    } else {
      rejectInquireNidByCustomerIdFn(
        props.userId,
        reasonCode.current,
        reason.current
      );
    }
  };

  const rejectInquireNidFn = async (id, current, reson) => {
    if (lastInquiry) {
      try {
        let params = {
          id: id,
          current: current,
          reason: reson,
        };
        const response = await rejectInquireNid(params);
        let data = response?.data;   
        if (!data.success) ErrorHandlingAPI(data);
      } catch (err) {        
        ErrorHandling(err, "reject error");
      }
      finally{
        setShowSpinnerReject(false);
        setRejectBtn(false);
        setPageData();
      }
    } else {
      WarningToast(Constants.authAcceptNotPossible);
    }
  };

  const rejectInquireNidByCustomerIdFn = async (id, current, reason) => {
      try {
        let params = {
          id:id,
          current:current,
          reason:reason,
        };
                const response = await rejectInquireNidByCustomerId( params );
                let data = response?.data;   
        if (!data.success) ErrorHandlingAPI(data);
      } catch (err) {     
        ErrorHandling(err, "reject NID with no history error");
      }
      finally{
        setShowSpinnerReject(false);
        setRejectBtn(false);
        setPageData();
      }
    
  };



  const openRejectModal = (e) => {    
    e.preventDefault();
    setShow(true);
  };


  return (
    <main>
      {!props.login ? (
        <NotLogin></NotLogin>
      ) : loading ? (
        <Loading></Loading>
      ) : customer && customer.nidInquiryStatus !== "None" ? (
        <>
          <div className="top-margin"></div>
          <div className="user-info-container user-docs-container user-service-container">
            <div className="user-info">
              <h1>
                {Headings.AuthPageTitle}
                <>
                  <span
                    className={getNidInquiryStatusTextUsetInfo(
                      customer.nidInquiryStatus
                    ).label}
                  >
                    (
                    {getNidInquiryStatusTextUsetInfo(customer.nidInquiryStatus).txt}
                    )
                  </span>
                </>
              </h1>
              <div className="divider"></div>
              <Row className="user-docs">
                <Col>
                  <PartOne
                    customer={customer}
                    setCustomer={setCustomer}
                    lastInquiry={lastInquiry}
                    setRejectBtn={setRejectBtn}
                    rejectBtn={rejectBtn}
                    acceptBtn={acceptBtn}
                    setAcceptBtn={setAcceptBtn}
                    verifyBtn={verifyBtn}
                    setVerifyBtn={setVerifyBtn}
                  ></PartOne>
                </Col>
                <Col>
                  <PartTwo backImage={backImage} customer={customer}></PartTwo>
                </Col>
              </Row>
              {customer.nidInquiryStatus === "ReadyForInquiry" ||
              customer.nidInquiryStatus === "InProgress" ? (
                <div className="text-left ml-65px">
                  <div>
                    {!showVerifySpinner ? (
                      <Button
                        className="submit-button big"
                        variant="primary"
                        disabled={verifyBtn}
                        onClick={(e) => inquire(e)}
                      >
                        {FormsButtonTypeUserInfo("Inquire")}
                      </Button>
                    ) : (
                      <Button className="submit-button big" variant="primary">
                        <FontAwesomeIcon icon={faSpinner} spin />
                      </Button>
                    )}
                  </div>
                  <div>
                    {!showSpinnerReject ? (
                      <Button
                        className="submit-button cancel-button"
                        variant="danger"
                        disabled={rejectBtn}
                        onClick={(e) => openRejectModal(e)}
                      >
                        {FormsButtonTypeUserInfo("Reject")}
                      </Button>
                    ) : (
                      <Button
                        className="submit-button cancel-button"
                        variant="danger"
                      >
                        <FontAwesomeIcon icon={faSpinner} spin />
                      </Button>
                    )}
                    {!showSpinnerAccept ? (
                      <Button
                        className="submit-button accept-button"
                        variant="success"
                        disabled={acceptBtn}
                        onClick={(e) => acceptInquire(e)}
                      >
                        {FormsButtonTypeUserInfo("Accept")}
                      </Button>
                    ) : (
                      <Button
                        className="submit-button accept-button"
                        variant="success"
                      >
                        <FontAwesomeIcon icon={faSpinner} spin />
                      </Button>
                    )}
                  </div>
                </div>
              ) : (
                <></>
              )}
              <div className="divider"></div>
              {customer && <AuthHistory customer={customer}></AuthHistory>}
              <div className="pb-30px"></div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="top-margin"></div>
          <div className="user-info-container user-docs-container user-service-container">
            <div className="user-info">
              <h1>{Headings.AuthPageTitle}</h1>
              <div className="divider"></div>
              <h1 className="validation-error text-center mt-5 pt-5">
                {Headings.NoAuthAllowance}
              </h1>
            </div>
          </div>
        </>
      )}
      <ModalContainer
        show={show}
        type={ModalContentType.RejectUser()}
        title={Headings.RejectReasonModalTitle}
        handleClose={handleClose}
        data={{
          reason: reason,
          reasonCode: reasonCode,
          selectedRejectCheckBox: selectedRejectCheckBox,
        }}
      ></ModalContainer>
    </main>
  );
}

export default UserAuth;
